import { render, staticRenderFns } from "./backups.vue?vue&type=template&id=9ee28eaa&"
import script from "./backups.vue?vue&type=script&lang=js&"
export * from "./backups.vue?vue&type=script&lang=js&"
import style0 from "./backups.vue?vue&type=style&index=0&id=9ee28eaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports